<template>
    <router-link v-if="link" :to="{path:link}" class="menu_item" :class="{'has-sidebar':use_dropdown}" :activeClass="'active'">
        <div class="link-wrapper">
            <slot name="icon"></slot>
            <div v-if="icon" :class="icon+' menu_item_img'"></div>
            <p class="menu_item_text" v-html="label"></p>
        </div>
        <div v-if="use_dropdown" class="navigation-dropdown">
            <slot name="sidebar"></slot>
        </div>
    </router-link>
    <div v-else class="menu_item" :class="{'has-sidebar':use_dropdown}" v-on:click="on_click($event)">
        <div class="link-wrapper">
            <slot name="icon"></slot>
            <div v-if="icon" :class="icon+' menu_item_img'"></div>
            <p class="menu_item_text" v-html="label"></p>
        </div>
        <div v-if="use_dropdown" class="navigation-dropdown">
            <slot name="sidebar"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NavigationItem",
        components: {},
        data(){
            return{
                use_dropdown:false
            };
        },
        props:{
            link:{
                type:String,
                default:null
            },
            label:{
                type:String,
                default:null
            },
            icon:{
                type:String,
                default:null
            },
            click:null
        },
        mounted(){
            if(typeof this.$slots["sidebar"] != "undefined"){
                this.use_dropdown = true;
            }
        },
        methods:{
            on_click(event){
                if(typeof this.click == "function"){
                    this.click.call(this,event);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    
</style>